import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { KTIcon, KTSVG } from '../../../_metronic/helpers';
import { ShowToast } from '../../../common/Toastr';
import { RolePermissionClass } from "./interfaces/RolePermissionClass";
import fetchAPI from "../../../common/fetchAPI";
import Select, { StylesConfig } from 'react-select';
import './RolePermission.css';
import { getPagePermissionsAsync } from '../../../common/GlobalSlice';
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Loader from "../../../common/Loader";
import { getValueFromResource } from '../../../common/timeLiveFunction';
import { Dropdown } from "react-bootstrap";
import clsx from "clsx";
import { TOOLTIP_STYLE } from "../../../common/TooltipStyle";
import infoSVG from "../../../assets/image/info-SVG.svg";
import { Tooltip as ReactTooltip } from 'react-tooltip';

const customButtonStyle = {
    padding: '0.25rem 0.5rem', // Adjust padding as needed
    fontSize: '0.95rem', // Adjust font size as needed
    fontWeight: 'inherit',
    lineHeight: 1.5, // Adjust line height as needed
    borderRadius: '0.5rem', // Adjust border radius as needed
    marginRight: '5px',
    marginBottom: '3px'
};

// Define styles for selected row
const selectedRowStyle = {
    backgroundColor: '#d9d9d9',
    cursor: 'default',
};

// Define styles for card
const cardStyle = {
    border: '1px solid #ccc'
};



export const RolePermission = () => {

    const dispatch = useAppDispatch();
    // const { accountId} = useAppSelector((state) => state.timesheet);
    const { sessionAccountId, maxMenuHeight, manageTerminologyList } = useAppSelector((state) => state.globalState);
    const [selectedRowIndex, setSelectedRowIndex] = useState<number>(-1);
    const [systemSecurityCategoryPageId, setSystemSecurityCategoryPageId] = useState<number>(-1);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [isShowDataOptions, setIsShowDataOptions] = useState<boolean>(false);
    const [isReload, setIsReload] = useState<boolean>(false);
    const [selectedDefaultPage, setSelectedDefaultPage] = useState<{ value: string; label: string } | null>(null);
    const [defaultPageArray, setDefaultPageArray] = useState<any | ''>([]);
    const [selectedAccountRole, setSelectedAccountRole] = useState<{ value: string; label: string } | null>(null);
    const [accountRoleArray, setAccountRoleArray] = useState<any | ''>([]);
    const [rolePermissionList, setRolePermissionList] = useState<Array<RolePermissionClass>>([]);
    const [rolePermissionReadOnlyList, setRolePermissionReadOnlyList] = useState<Array<RolePermissionClass>>([]);
    const [wholeAccountPermissionsArray, setWholeAccountPermissionsArray] = useState<any | ''>([]);
    const [wholeAccountPermissionsReadOnlyArray, setWholeAccountPermissionsReadOnlyArray] = useState<any | ''>([]);
    const [isshow, setIsShow] = useState(false);
    const [schedulePageId,setSchedulePageId]=useState<any| null>('');

    // const [isGridView, setIsGridView] = useState<boolean>(false);
    // const [isButton, setIsButton] = useState<boolean>(false);
    const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete, isLoading } = useAppSelector((state) => state.globalState);

    const permissionList: any = [{ name: 'IsAllowList', id: 1, displayname: 'List \ View', icon: 'list', iconColor: '#0052cc' }, { name: 'IsAllowAdd', id: 2, displayname: 'Add', icon: 'save', iconColor: '#0052cc' }, { name: 'IsAllowEdit', id: 3, displayname: 'Edit', icon: 'pencil', iconColor: '#0052cc' }, { name: 'IsAllowDelete', id: 4, displayname: 'Delete', icon: 'trash', iconColor: '#f1416c' }];
    const location = useLocation();
    const navigate = useNavigate();
    const [updateTrigger, setUpdateTrigger] = useState(false);
    const { t } = useTranslation();

    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd.toLowerCase() === routeName.toLowerCase());
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        };

        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId, updateTrigger]);

    useEffect(() => {
        if (isReload) {
            getPermissionRoles();
        }
    }, [isReload])

    useEffect(() => {
        getPermissionRoles();
    }, [dispatch])

    useEffect(() => {
        getDataForDefaultPageDropDown();
    }, [])

    useEffect(() => {
        if (selectedAccountRole !== null) {
            const { value } = selectedAccountRole;
            setDefaultPageId(value);
        }
    }, [selectedAccountRole])


    const getPermissionRoles = async () => {
        try {
            const response = await fetchAPI("api/v2/PagePermission", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
            const json = await response.json();

            const rolePermissionData = JSON.parse(json.Data.rolePermissionData);
            setRolePermissionList(rolePermissionData);
            setRolePermissionReadOnlyList(rolePermissionData);

            const wholeAccountPermissionsData = JSON.parse(json.Data.WholeAccountPermissionsData);
            setWholeAccountPermissionsArray(wholeAccountPermissionsData);
            setWholeAccountPermissionsReadOnlyArray(wholeAccountPermissionsData);

            //setIsGridView(json.Data.IsGridView);
            //setIsButton(json.Data.IsButton);

        } catch (error) {
        }
    };

    const handleDefaultPageChange = async (data: any) => {
        const { value, label } = data;
        setSelectedDefaultPage({ value: value, label: label });
        await fetchAPI('api/v2/PagePermission/UpdateDefaultAccountPage/' + selectedAccountRole?.value + '/' + value, 'PUT', "", true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
    };

    const setDefaultPageId = async (accountRoleId: any) => {
        const response = await fetchAPI(`api/v2/PagePermission/DefaultPageId?AccountRoleId=${accountRoleId}`, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        const defaultPageId = json.Id;
        const foundItem = defaultPageArray.filter((item: any) => item.value == defaultPageId);
        if (foundItem.length > 0) {
            setSelectedDefaultPage({ value: foundItem[0].value, label: foundItem[0].label });
        }
        else {
            setSelectedDefaultPage(defaultPageArray[0]);
        }
    }

    const getDataForDefaultPageDropDown = async () => {
        await fetchAPI("api/v2/PagePermission/DefaultPageDropDown", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab")
            .then(response => response.json())
            .then(data => {
                data.Data.map((item: any) => {
                    item.value = item.SystemSecurityCategoryPageId;
                    item.label = item.SystemCategoryPageDescription;
                    delete item.SystemSecurityCategoryPageId;
                    delete item.SystemCategoryPageDescription;
                });
                data.Data.unshift({ value: '0', label: 'Select' })
                setDefaultPageArray(data.Data);

                getAccountRoleDropDown();
            })
            .catch(error => {
            });
    }

    const getAccountRoleDropDown = async () => {
        const response = await fetchAPI("api/v2/PagePermission/RolesAndPagePermissions", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        const rolesArray: any = JSON.parse(json.Data.RolesData);

        rolesArray.map((item: any) => {
            item.value = item.AccountRoleId;
            item.label = item.Role;
        });

        setAccountRoleArray(rolesArray);
        setSelectedAccountRole({ value: rolesArray[0].value, label: rolesArray[0].label });
    }

    const handleAccountRoleChange = (data: any) => {
        const { value, label } = data;
        setSelectedAccountRole({ value: value, label: label });
    };

    const handleRowClick = (selectedRow: RolePermissionClass, rowIndex: number) => {
        setIsShowDataOptions(selectedRow.IsShowDataOptions);
        setSelectedRowIndex(rowIndex);
        setSchedulePageId(selectedRow.SystemSecurityCategoryPageId);
        setIsModalOpen(true);
        setSystemSecurityCategoryPageId(selectedRow.SystemSecurityCategoryPageId);

    };
    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedRowIndex(-1);
         getPermissionRoles();

    };

    const handleCheckboxChange = (e: any, wholeAccountPermissionsRow: any) => {

        const updatedPermissionsArray = [...wholeAccountPermissionsArray];
        const indexToUpdate = updatedPermissionsArray.findIndex(item => item.AccountId === sessionAccountId && item.AccountRoleId === selectedAccountRole?.value && item.SystemSecurityCategoryPageId === wholeAccountPermissionsRow.SystemSecurityCategoryPageId && item.SystemPermissionId === wholeAccountPermissionsRow.SystemPermissionId);

        if (indexToUpdate !== -1) {
            updatedPermissionsArray[indexToUpdate] = {
                ...updatedPermissionsArray[indexToUpdate],
                [e.target.id]: e.target.checked, "isSelected": true
            };

            setWholeAccountPermissionsArray(updatedPermissionsArray);
        }

    };

    const setListViewDataOptionsByPageId = (selectedRow: any, wholeAccountPermissionsRow: any) => {
        return (
            <>
                {schedulePageId !== 80 && <td className="text-center">
                    <input
                        type="checkbox"
                        className="form-check-input custom-padding-right small-checkbox"
                        id="ShowMyProjectsData"
                        checked={wholeAccountPermissionsRow.ShowMyProjectsData}
                        onChange={(e) => { handleCheckboxChange(e, wholeAccountPermissionsRow) }}
                    />
                </td>}
                {schedulePageId !== 509 && schedulePageId !== 80 && <td className="text-center">
                    <input
                        type="checkbox"
                        className="form-check-input custom-padding-right small-checkbox"
                        id="ShowMyTeamsData"
                        checked={wholeAccountPermissionsRow.ShowMyTeamsData}
                        onChange={(e) => { handleCheckboxChange(e, wholeAccountPermissionsRow) }}
                    />
                </td>}
                {schedulePageId !== 509 && <td className="text-center">
                    <input
                        type="checkbox"
                        className="form-check-input custom-padding-right small-checkbox"
                        id="ShowMySubOrdinatesData"
                        checked={wholeAccountPermissionsRow.ShowMySubOrdinatesData}
                        onChange={(e) => { handleCheckboxChange(e, wholeAccountPermissionsRow) }}
                    />
                </td>}
            </>
        );
    }

    const setAddDataOptionsByPageId = (selectedRow: any, wholeAccountPermissionsRow: any) => {
        return (
            <>
                <td className="text-center">
                    <input type="checkbox" className="form-check-input custom-padding-right small-checkbox" id="ShowAllData" checked={wholeAccountPermissionsRow.ShowAllData} onChange={(e) => { handleCheckboxChange(e, wholeAccountPermissionsRow) }} />
                </td>
                <td className="text-center">
                {schedulePageId !== 509 && 
                    <input type="checkbox" className="form-check-input custom-padding-right small-checkbox" id="ShowMyData" checked={wholeAccountPermissionsRow.ShowMyData} onChange={(e) => { handleCheckboxChange(e, wholeAccountPermissionsRow) }} />
                }
                </td>
                {schedulePageId !== 80 && <td className="text-center">
                    <input type="checkbox" className="form-check-input custom-padding-right small-checkbox" id="ShowMyProjectsData" checked={wholeAccountPermissionsRow.ShowMyProjectsData} onChange={(e) => { handleCheckboxChange(e, wholeAccountPermissionsRow) }} />
                </td>}
               {schedulePageId !== 509 && schedulePageId !== 80 && <td className="text-center">
                    <input type="checkbox" className="form-check-input custom-padding-right small-checkbox" id="ShowMyTeamsData" checked={wholeAccountPermissionsRow.ShowMyTeamsData} onChange={(e) => { handleCheckboxChange(e, wholeAccountPermissionsRow) }} />
                </td>}
                {schedulePageId !== 509 && <td className="text-center">
                    <input type="checkbox" className="form-check-input custom-padding-right small-checkbox" id="ShowMySubOrdinatesData" checked={wholeAccountPermissionsRow.ShowMySubOrdinatesData} onChange={(e) => { handleCheckboxChange(e, wholeAccountPermissionsRow) }} />
                </td>}
            </>
        );
    }

    const setEditDataOptionsByPageId = (selectedRow: any, wholeAccountPermissionsRow: any) => {
        return (
            <>
                <td className="text-center">
                    <input type="checkbox" className="form-check-input custom-padding-right small-checkbox" id="ShowAllData" checked={wholeAccountPermissionsRow.ShowAllData} onChange={(e) => { handleCheckboxChange(e, wholeAccountPermissionsRow) }} />
                </td>
                <td className="text-center">
                {schedulePageId !== 509 && 
                    <input type="checkbox" className="form-check-input custom-padding-right small-checkbox" id="ShowMyData" checked={wholeAccountPermissionsRow.ShowMyData} onChange={(e) => { handleCheckboxChange(e, wholeAccountPermissionsRow) }} />
                }
                </td>
                {schedulePageId !== 80 && <td className="text-center">
                    <input type="checkbox" className="form-check-input custom-padding-right small-checkbox" id="ShowMyProjectsData" checked={wholeAccountPermissionsRow.ShowMyProjectsData} onChange={(e) => { handleCheckboxChange(e, wholeAccountPermissionsRow) }} />
                </td>}
                {schedulePageId !== 509 && schedulePageId !== 80 && <td className="text-center">
                    <input type="checkbox" className="form-check-input custom-padding-right small-checkbox" id="ShowMyTeamsData" checked={wholeAccountPermissionsRow.ShowMyTeamsData} onChange={(e) => { handleCheckboxChange(e, wholeAccountPermissionsRow) }} />
                </td>}
               {schedulePageId !== 509 && <td className="text-center">
                    <input type="checkbox" className="form-check-input custom-padding-right small-checkbox" id="ShowMySubOrdinatesData" checked={wholeAccountPermissionsRow.ShowMySubOrdinatesData} onChange={(e) => { handleCheckboxChange(e, wholeAccountPermissionsRow) }} />
                </td>}
            </>
        );
    }

    const setDeleteDataOptionsByPageId = (selectedRow: any, wholeAccountPermissionsRow: any) => {
        return (
            <>
                 {schedulePageId !== 509 && <td className="text-center">
                    <input type="checkbox" className="form-check-input custom-padding-right small-checkbox" id="ShowAllData" checked={wholeAccountPermissionsRow.ShowAllData} onChange={(e) => { handleCheckboxChange(e, wholeAccountPermissionsRow) }} />
                </td>}
                {schedulePageId !== 509 && 
                <td className="text-center">
                    <input type="checkbox" className="form-check-input custom-padding-right small-checkbox" id="ShowMyData" checked={wholeAccountPermissionsRow.ShowMyData} onChange={(e) => { handleCheckboxChange(e, wholeAccountPermissionsRow) }} />
                </td>
                 }
                 {schedulePageId !== 509 && schedulePageId !== 80 && <td className="text-center">
                    <input type="checkbox" className="form-check-input custom-padding-right small-checkbox" id="ShowMyProjectsData" checked={wholeAccountPermissionsRow.ShowMyProjectsData} onChange={(e) => { handleCheckboxChange(e, wholeAccountPermissionsRow) }} />
                </td>}
                {schedulePageId !== 509 && schedulePageId !== 80 && <td className="text-center">
                    <input type="checkbox" className="form-check-input custom-padding-right small-checkbox" id="ShowMyTeamsData" checked={wholeAccountPermissionsRow.ShowMyTeamsData} onChange={(e) => { handleCheckboxChange(e, wholeAccountPermissionsRow) }} />
                </td>}
                {schedulePageId !== 509 && <td className="text-center">
                    <input type="checkbox" className="form-check-input custom-padding-right small-checkbox" id="ShowMySubOrdinatesData" checked={wholeAccountPermissionsRow.ShowMySubOrdinatesData} onChange={(e) => { handleCheckboxChange(e, wholeAccountPermissionsRow) }} />
                </td>}
            </>
        );
    }

    const applyPermissionInModal = (Detail: any, permission: any, wholeAccountPermissionsArray: any) => {
        let itemfound = wholeAccountPermissionsArray.filter((item: any) => item.SystemSecurityCategoryPageId === Detail.SystemSecurityCategoryPageId && item.SystemPermissionId === permission.id && selectedAccountRole?.value === item.AccountRoleId && item.AccountPagePermissionId !== -1)

        if (itemfound[0]) {
            if (itemfound[0].AccountId == sessionAccountId && itemfound[0].AccountRoleId == selectedAccountRole?.value && Detail.SystemSecurityCategoryPageId == itemfound[0].SystemSecurityCategoryPageId) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }

    const handlePermissionInModalChange = (e: any, Detail: any, permission: any, wholeAccountPermissionsArray: any) => {
         setIsShow(e.target.check);
        if (e.target.checked) {
            let itemfound = wholeAccountPermissionsArray
                .find((item: any) => item.SystemSecurityCategoryPageId === Detail.SystemSecurityCategoryPageId &&
                    item.SystemPermissionId === permission.id &&
                    selectedAccountRole?.value === item.AccountRoleId
                );

            if (!itemfound) {

                setWholeAccountPermissionsArray((prevPermissionsArray: any) => [
                    ...prevPermissionsArray,
                    {
                        "AccountPagePermissionId": 0,
                        "AccountId": sessionAccountId,
                        "AccountRoleId": selectedAccountRole?.value,
                        "SystemSecurityCategoryPageId": Detail.SystemSecurityCategoryPageId,
                        "SystemPermissionId": permission.id,
                        "ShowAllData": false,
                        "ShowMyData": false,
                        "ShowMyProjectsData": false,
                        "ShowMyTeamsData": false,
                        "TillDate": null,
                        "TillHours": null,
                        "ShowMySubOrdinatesData": false,
                        "isSelected": true

                    }
                ]);
            }
            else {

                itemfound.AccountPagePermissionId = 0;

                const updatedItems = wholeAccountPermissionsArray.map((item: any) => {
                    if (item.SystemSecurityCategoryPageId === Detail.SystemSecurityCategoryPageId && item.SystemPermissionId === permission.id && selectedAccountRole?.value === item.AccountRoleId) {
                        itemfound.isSelected = true;
                        return itemfound;
                    }
                    return item;
                });

                setWholeAccountPermissionsArray(updatedItems);
            }

        }
        else {
            let itemfound = wholeAccountPermissionsArray
                .find((item: any) => item.SystemSecurityCategoryPageId === Detail.SystemSecurityCategoryPageId &&
                    item.SystemPermissionId === permission.id &&
                    selectedAccountRole?.value === item.AccountRoleId);

            if (itemfound) {
                itemfound.AccountPagePermissionId = -1;
                itemfound.isSelected = true;
                const updatedItems = wholeAccountPermissionsArray.map((item: any) => {
                    if (item.SystemSecurityCategoryPageId === Detail.SystemSecurityCategoryPageId && item.SystemPermissionId === permission.id && selectedAccountRole?.value === item.AccountRoleId) {
                        return itemfound;
                    }
                    return item;
                });
                setWholeAccountPermissionsArray(updatedItems);
            }
        }
        if (!e.target.checked) {
            const updatedPermissionsArray = wholeAccountPermissionsArray.map((item: any) => {
                if (item.SystemSecurityCategoryPageId === Detail.SystemSecurityCategoryPageId &&
                    item.SystemPermissionId === permission.id &&
                    selectedAccountRole?.value === item.AccountRoleId) {

                    return {
                        ...item,
                        ShowAllData: false,
                        ShowMyData: false,
                        ShowMyProjectsData: false,
                        ShowMyTeamsData: false,
                        ShowMySubOrdinatesData: false,
                        isSelected: true
                    };
                }
                return item;
            });

            setWholeAccountPermissionsArray(updatedPermissionsArray);
        }
        UpdateRolePermissionStates(Detail.SystemSecurityCategoryPageId, e.target.id, e.target.checked)
    };

    const UpdateRolePermissionStates = (SystemSecurityCategoryPageId: any, FieldName: any, ValueToUpdate: any) => {


        const currentindex = rolePermissionList.findIndex((item: any) => item.SystemSecurityCategoryPageId == SystemSecurityCategoryPageId);
        const newArray = [...rolePermissionList];
        if (currentindex !== -1) {
            newArray[currentindex] = {
                ...newArray[currentindex],
                [FieldName]: ValueToUpdate
            };

            setRolePermissionList(newArray);
        }
    };

    const updatepermissions = async () => {
        const response = await fetchAPI('api/v2/PagePermission/UpdatePermissions', 'POST', { rolePermissionList: rolePermissionList, wholeAccountPermissionsArray: wholeAccountPermissionsArray, AccountRoleId: selectedAccountRole?.value, DefaultAccountPageId: selectedDefaultPage?.value }, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
        const json = await response.json();
        if (json.StatusCode == "200") {
            setIsReload(true);
            ShowToast("Permissions Update Successfully", 'Success', "success", "toast-top-right");
            closeModal();
        }
        else {
            setIsReload(false);
            ShowToast('error', json.ResponseMessage, "error", "toast-top-right");
        }
        setUpdateTrigger(true);

    }
    return (
        <>


            {isLoading && <Loader />}


            <div className="card card-custom admin-card">
                <div className="card-header sticky-top bg-white fixed-top dropdown-zindex">
                    <h3 className="card-title fw-bold headerTitle d-flex align-items-center gap-1">
                        {/* {t('Role Permissions')} */}
                        {getValueFromResource('Role Permissions', dispatch, t)}
                        <div
                            style={{ marginBottom: "2px" }}
                            data-tooltip-id="tooltip-role-permission"
                            data-tooltip-content={getValueFromResource('Define which pages each role can access and what actions they can perform, including view, add, edit, delete, and record-level access such as My, My Team, or All records.', dispatch, t)}
                        >
                            <img src={infoSVG} alt="" width={12} height={12} className="tooltip-info-icon" />
                        </div>
                    </h3>
                    {/* <div className='bullet bg-secondary h-35px w-1px mx-3'></div> */}
                    <div className="card-toolbar align-items-center">
                        <div className="d-flex align-items-center">
                            {/* <label className="form-label" style={{ marginRight: '5px',marginTop:'5px' }}>Select Role</label> */}
                            <span className="  d-block fs-7" style={{ marginRight: '5px' }}>
                                {/* {t('Select Role')} */}
                                {getValueFromResource('Select Role', dispatch, t)}
                            </span>
                            <Select
                                value={selectedAccountRole}
                                className="basic-single"
                                classNamePrefix="select"
                                isSearchable={true}
                                name="ddlAccountRoleId"
                                onChange={handleAccountRoleChange}
                                options={accountRoleArray}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                            />
                        </div>
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div className="d-flex align-items-center">
                            {/* <label className="form-label" style={{ marginRight: '5px',marginTop:'5px' }}>Default Page</label> */}
                            <span className="   d-block fs-7" style={{ marginRight: '5px' }}>
                                {/* {t('Default Page')} */}
                                {getValueFromResource('Default Page', dispatch, t)}
                            </span>
                            <Select
                                value={selectedDefaultPage}
                                className="basic-single "
                                classNamePrefix="select"
                                isSearchable={true}
                                name="ddlDefaultPage"
                                onChange={handleDefaultPageChange}
                                options={defaultPageArray}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}

                            />
                        </div>
                    </div>
                </div>

                {/* <div className="card-body" style={{ display: `${isGridView ? `block` : `none`}` }}> */}
                {/* <div className="card-body" > */}
                <div className="card-Report-body" >
                    <div className="table-responsive">
                        <table className="table table-row-bordered table-row-gray-300 align-middle gs-0 gy-3 " >
                            <thead >
                                <tr className="fw-bold text-muted thHeading" >
                                    {/* <tr className="fw-bold text-muted" style={{fontSize:'10px',fontWeight:'500'}}> */}
                                    <th className='w-15'>
                                        {/* {t('Category')} */}
                                        {getValueFromResource('Category', dispatch, t)}
                                    </th>
                                    <th className='w-15'>
                                        {/* {t('Page Description')} */}
                                        {getValueFromResource('Page Description', dispatch, t)}
                                    </th>
                                    <th className='w-30'>
                                        {/* {t('Permissions')} */}
                                        {getValueFromResource('Permissions', dispatch, t)}
                                    </th>
                                    {/* <th className='w-30'>{t('Allowed Permissions')}</th> */}
                                    <th className='w-30'>  {getValueFromResource('Allowed Permissions', dispatch, t)}</th>
                                    <th className='w-30'></th>
                                    <th className='w-10 text-center'> </th>

                                </tr>
                            </thead>
                            <tbody>

                                {rolePermissionList.length > 0 && rolePermissionList.map((Detail: any, i: any) => {
                                    return (
                                        <tr key={i}
                                            onClick={() => handleRowClick(Detail, i)}
                                            style={selectedRowIndex === i ? selectedRowStyle : { cursor: 'pointer' }}

                                    >
                                        <td>
                                            <span className="text-muted   d-block fs-7">{getValueFromResource(`${Detail.SystemSecurityCategory}`,dispatch ,t)}</span>
                                            {/* <span className="text-muted   d-block fs-7">{Detail.SystemSecurityCategory}</span> */}
                                        </td>
                                        {/* <td>
                                            <span className="text-muted  d-block fs-7">{Detail.SystemCategoryPageDescription}</span>
                                        </td> */}
                                        <td>
                                            <span className="text-muted d-block fs-7">
                                                {Detail.SystemCategoryPageDescription === "Admin Options"
                                                    ? getValueFromResource("Settings", dispatch, t)
                                                    : getValueFromResource(`${Detail.SystemCategoryPageDescription}`, dispatch, t)} 
                                                    {/* Detail.SystemCategoryPageDescription */}
                                            </span>
                                        </td>
                                            <td>
                                                {(() => {
                                                    let hasAnyPermission = false; 

                                                    const renderedPermissions = ["List", "Add", "Edit", "Delete"].map((permissionType) => {
                                                        let permissionId = 0;
                                                        let permissionLabel = "";

                                                        switch (permissionType) {
                                                            case "List":
                                                                permissionId = 1;
                                                                permissionLabel = getValueFromResource("List / View", dispatch, t);
                                                                break;
                                                            case "Add":
                                                                permissionId = 2;
                                                                permissionLabel = getValueFromResource("Add", dispatch, t);
                                                                break;
                                                            case "Edit":
                                                                permissionId = 3;
                                                                permissionLabel = getValueFromResource("Edit", dispatch, t);
                                                                break;
                                                            case "Delete":
                                                                permissionId = 4;
                                                                permissionLabel = getValueFromResource("Delete", dispatch, t);
                                                                break;
                                                            default:
                                                                break;
                                                        }
                                                        if (
                                                            (Detail.SystemSecurityCategoryPageId === 506 && permissionType === "Delete") ||
                                                            (Detail.SystemSecurityCategoryPageId === 507 &&
                                                                (permissionType === "List" || permissionType === "Edit"))
                                                        ) {
                                                            return null;
                                                        }

                                                        const hasPermission = wholeAccountPermissionsArray.some(
                                                            (item: any) =>
                                                                item.SystemSecurityCategoryPageId === Detail.SystemSecurityCategoryPageId &&
                                                                item.AccountId === sessionAccountId &&
                                                                item.AccountRoleId === selectedAccountRole?.value &&
                                                                item.SystemPermissionId === permissionId &&
                                                                ((permissionType === "List" && Detail.IsAllowList) ||
                                                                    (permissionType === "Add" && Detail.IsAllowAdd) ||
                                                                    (permissionType === "Edit" && Detail.IsAllowEdit) ||
                                                                    (permissionType === "Delete" && Detail.IsAllowDelete))
                                                        );

                                                        if (hasPermission) {
                                                            hasAnyPermission = true; 
                                                            return (
                                                                <React.Fragment key={permissionType}>
                                                                    <span
                                                                        className={`btn btn-light-${permissionType === "List"
                                                                                ? "primary"
                                                                                : permissionType === "Add"
                                                                                    ? "success"
                                                                                    : permissionType === "Edit"
                                                                                        ? "warning"
                                                                                        : "danger"
                                                                            } btn-bs-btn-font-weight fs-7`}
                                                                        style={customButtonStyle}
                                                                    >
                                                                        {permissionLabel}
                                                                    </span>
                                                                    <br />
                                                                </React.Fragment>
                                                            );
                                                        }

                                                        return null;
                                                    });
                                                    if (!hasAnyPermission) {
                                                        return <span className="text-muted">No Permission</span>;
                                                    }

                                                    return renderedPermissions;
                                                })()}
                                            </td>

                                           
                                            <td style={{ verticalAlign: 'top' }}>
                                                {Detail.IsShowDataOptions && wholeAccountPermissionsArray
                                                    .filter((item: any) =>
                                                        item.SystemSecurityCategoryPageId === Detail.SystemSecurityCategoryPageId &&
                                                        item.AccountId === sessionAccountId &&
                                                        item.AccountRoleId === selectedAccountRole?.value
                                                    )
                                                    .sort((a: any, b: any) => a.SystemPermissionId - b.SystemPermissionId) 
                                                    .map((wholeAccountPermissionsRow: any, i: any) => {
                                                        if (wholeAccountPermissionsRow.SystemPermissionId === 1) {
                                                            return (
                                                                <>
                                                                    {Detail.SystemSecurityCategoryPageId !== 124 && Detail.SystemSecurityCategoryPageId !== 27 && (
                                                                        <>
                                                                            {wholeAccountPermissionsRow.ShowAllData && (
                                                                                <span key={`list-ShowAllData-${i}`} className="btn btn-all-color btn-bs-btn-font-weight" style={customButtonStyle}>

                                                                                    {getValueFromResource('All', dispatch, t)}
                                                                                </span>
                                                                            )}
                                                                            {wholeAccountPermissionsRow.ShowMyData && (
                                                                                <span key={`list-ShowMyData-${i}`} className="btn btn-my-color btn-bs-btn-font-weight" style={customButtonStyle}>

                                                                                    {getValueFromResource('My', dispatch, t)}
                                                                                </span>
                                                                            )}
                                                                            {wholeAccountPermissionsRow.ShowMyProjectsData && (
                                                                                <span key={`list-ShowMyProjectsData-${i}`} className="btn btn-myproject-color btn-bs-btn-font-weight" style={customButtonStyle}>
                                                                                    {getValueFromResource('My Projects', dispatch, t)}
                                                                                </span>
                                                                            )}
                                                                            {wholeAccountPermissionsRow.ShowMyTeamsData && (
                                                                                <span key={`list-ShowMyTeamsData-${i}`} className="btn btn-myteam-color btn-bs-btn-font-weight" style={customButtonStyle}>
                                                                                    {getValueFromResource('My Teams', dispatch, t)}
                                                                                </span>
                                                                            )}
                                                                            {wholeAccountPermissionsRow.ShowMySubOrdinatesData && (
                                                                                <span key={`list-ShowMySubOrdinatesData-${i}`} className="btn btn-mysubordinate-color btn-bs-btn-font-weight" style={customButtonStyle}>
                                                                                    {getValueFromResource('My Sub-Ordinate', dispatch, t)}
                                                                                </span>
                                                                            )}
                                                                            <br />
                                                                        </>
                                                                    )}
                                                                    {Detail.SystemSecurityCategoryPageId === 124 && (
                                                                        <>
                                                                            {wholeAccountPermissionsRow.ShowAllData && (
                                                                                <span key={`list-ShowAllData-${i}`} className="btn btn-all-color btn-bs-btn-font-weight" style={customButtonStyle}>

                                                                                    {getValueFromResource('All', dispatch, t)}
                                                                                </span>
                                                                            )}
                                                                            {wholeAccountPermissionsRow.ShowMyData && (
                                                                                <span key={`list-ShowMyData-${i}`} className="btn btn-my-color btn-bs-btn-font-weight" style={customButtonStyle}>

                                                                                    {getValueFromResource('My', dispatch, t)}
                                                                                </span>
                                                                            )}
                                                                        </>
                                                                    )}
                                                                </>
                                                            );
                                                        }
                                                        else if (wholeAccountPermissionsRow.SystemPermissionId === 2) {
                                                            return (
                                                                <>

                                                                    {Detail.SystemSecurityCategoryPageId !== 124 && Detail.SystemSecurityCategoryPageId !== 18 &&
                                                                        Detail.SystemSecurityCategoryPageId !== 135 && Detail.SystemSecurityCategoryPageId !== 27 && (
                                                                            <>
                                                                                {wholeAccountPermissionsRow.ShowAllData && (
                                                                                    <span key={`Add-ShowAllData-${i}`} className="btn btn-all-color btn-bs-btn-font-weight" style={customButtonStyle}>

                                                                                        {getValueFromResource('All', dispatch, t)}
                                                                                    </span>
                                                                                )}
                                                                                {wholeAccountPermissionsRow.ShowMyData && (
                                                                                    <span key={`Add-ShowMyData-${i}`} className="btn btn-my-color btn-bs-btn-font-weight" style={customButtonStyle}>

                                                                                        {getValueFromResource('My', dispatch, t)}
                                                                                    </span>
                                                                                )}
                                                                                {wholeAccountPermissionsRow.ShowMyProjectsData && (
                                                                                    <span key={`Add-ShowMyProjectsData-${i}`} className="btn btn-myproject-color btn-bs-btn-font-weight" style={customButtonStyle}>

                                                                                        {getValueFromResource('My Projects', dispatch, t)}
                                                                                    </span>
                                                                                )}
                                                                                {wholeAccountPermissionsRow.ShowMyTeamsData && (
                                                                                    <span key={`Add-ShowMyTeamsData-${i}`} className="btn btn-myteam-color btn-bs-btn-font-weight" style={customButtonStyle}>
                                                                                        {getValueFromResource('My Teams', dispatch, t)}
                                                                                    </span>
                                                                                )}
                                                                                {wholeAccountPermissionsRow.ShowMySubOrdinatesData && (
                                                                                    <span key={`Add-ShowMySubOrdinatesData-${i}`} className="btn btn-mysubordinate-color btn-bs-btn-font-weight" style={customButtonStyle}>
                                                                                        {getValueFromResource('My Sub-Ordinate', dispatch, t)}
                                                                                    </span>
                                                                                )}
                                                                                <br />
                                                                            </>
                                                                        )}
                                                                </>
                                                            );
                                                        }
                                                        else if (wholeAccountPermissionsRow.SystemPermissionId === 3) {
                                                            return (
                                                                <>

                                                                    {Detail.SystemSecurityCategoryPageId !== 124 &&
                                                                        Detail.SystemSecurityCategoryPageId !== 135 && (
                                                                            <>
                                                                                {wholeAccountPermissionsRow.ShowAllData && (
                                                                                    <span key={`Edit-ShowAllData-${i}`} className="btn btn-all-color btn-bs-btn-font-weight" style={customButtonStyle}>
                                                                                        {/* All */}
                                                                                        {getValueFromResource('All', dispatch, t)}
                                                                                    </span>
                                                                                )}
                                                                                {wholeAccountPermissionsRow.ShowMyData && (
                                                                                    <span key={`Edit-ShowMyData-${i}`} className="btn btn-my-color btn-bs-btn-font-weight" style={customButtonStyle}>

                                                                                        {getValueFromResource('My', dispatch, t)}
                                                                                    </span>
                                                                                )}
                                                                                {wholeAccountPermissionsRow.ShowMyProjectsData && (
                                                                                    <span key={`Edit-ShowMyProjectsData-${i}`} className="btn btn-myproject-color btn-bs-btn-font-weight" style={customButtonStyle}>
                                                                                        {getValueFromResource('My Projects', dispatch, t)}
                                                                                    </span>
                                                                                )}
                                                                                {wholeAccountPermissionsRow.ShowMyTeamsData && (
                                                                                    <span key={`Edit-ShowMyTeamsData-${i}`} className="btn btn-myteam-color btn-bs-btn-font-weight" style={customButtonStyle}>
                                                                                        {getValueFromResource('My Teams', dispatch, t)}
                                                                                    </span>
                                                                                )}
                                                                                {wholeAccountPermissionsRow.ShowMySubOrdinatesData && (
                                                                                    <span key={`Edit-ShowMySubOrdinatesData-${i}`} className="btn btn-mysubordinate-color btn-bs-btn-font-weight" style={customButtonStyle}>
                                                                                        {getValueFromResource(' My Sub-Ordinate', dispatch, t)}
                                                                                    </span>
                                                                                )}
                                                                                <br />
                                                                            </>
                                                                        )}
                                                                </>
                                                            );
                                                        }
                                                        else if (wholeAccountPermissionsRow.SystemPermissionId === 4) {
                                                            return (
                                                                <>

                                                                    {Detail.SystemSecurityCategoryPageId !== 124 && Detail.SystemSecurityCategoryPageId !== 18 &&
                                                                        Detail.SystemSecurityCategoryPageId !== 135 && (
                                                                            <>
                                                                                {wholeAccountPermissionsRow.ShowAllData && (
                                                                                    <span key={`Delete-ShowAllData-${i}`} className="btn btn-all-color btn-bs-btn-font-weight" style={customButtonStyle}>
                                                                                        {getValueFromResource('All', dispatch, t)}
                                                                                    </span>
                                                                                )}
                                                                                {wholeAccountPermissionsRow.ShowMyData && (
                                                                                    <span key={`Delete-ShowMyData-${i}`} className="btn btn-my-color btn-bs-btn-font-weight" style={customButtonStyle}>

                                                                                        {getValueFromResource('My', dispatch, t)}
                                                                                    </span>
                                                                                )}
                                                                                {wholeAccountPermissionsRow.ShowMyProjectsData && (
                                                                                    <span key={`Delete-ShowMyProjectsData-${i}`} className="btn btn-myproject-color btn-bs-btn-font-weight" style={customButtonStyle}>

                                                                                        {getValueFromResource('My Projects', dispatch, t)}
                                                                                    </span>
                                                                                )}
                                                                                {wholeAccountPermissionsRow.ShowMyTeamsData && (
                                                                                    <span key={`Delete-ShowMyTeamsData-${i}`} className="btn btn-myteam-color btn-bs-btn-font-weight" style={customButtonStyle}>

                                                                                        {getValueFromResource('My Teams', dispatch, t)}
                                                                                    </span>
                                                                                )}
                                                                                {wholeAccountPermissionsRow.ShowMySubOrdinatesData && (
                                                                                    <span key={`Delete-ShowMySubOrdinatesData-${i}`} className="btn btn-mysubordinate-color btn-bs-btn-font-weight" style={customButtonStyle}>

                                                                                        {getValueFromResource('My Sub-Ordinate', dispatch, t)}
                                                                                    </span>
                                                                                )}
                                                                                <br />
                                                                            </>
                                                                        )}
                                                                </>
                                                            );
                                                        }
                                                        return null;
                                                    })}
                                            </td>
                                            <td className='text-center' >
                                                <Dropdown
                                                    style={{ marginLeft: 1 }}
                                                    className={clsx('cursor-pointer symbol')}
                                                    data-kt-menu-attach='parent'
                                                    data-kt-menu-placement='bottom-end'
                                                >
                                                    <Dropdown.Toggle
                                                        variant="transparent"
                                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                                        data-tooltip-id="tooltip-Description"
                                                        data-tooltip-content=
                                                        // t("More")}
                                                        {getValueFromResource('Edit Permissions', dispatch, t)}
                                                        data-tooltip-place="top"
                                                    >
                                                        <i className="bi bi-pencil fs-7"></i>
                                                    </Dropdown.Toggle>
                                                </Dropdown>
                                            </td>



                                        </tr>
                                    )
                                })}

                            </tbody>
                        </table >
                        {rolePermissionList.length === 0 &&
                            <div className=''>
                                <p className='noDataFound'>
                                    {/* {t('No Record Found')} */}
                                    {getValueFromResource('No Record Found', dispatch, t)}
                                </p>
                            </div>
                        }
                    </div>
                </div>
            </div>


            {isModalOpen && selectedRowIndex != -1 &&

                <div className="modal drawer-overlay" style={{ display: 'block' }} >
                    <div className={`modal-dialog ${isShowDataOptions ? 'modal-lg' : 'modal-sm'} `}>
                        <div className="modal-content RP_table">
                            <div className="modal-header">
                                {/* <h3 className="modal-title" style={{ fontSize: '16px' }}>
                                    {t(`${rolePermissionList[selectedRowIndex].SystemCategoryPageDescription}`)}                                
                                </h3> */}
                                <h3 className="modal-title" style={{ fontSize: '16px' }}>
                                    {t(
                                        rolePermissionList[selectedRowIndex].SystemCategoryPageDescription === "Admin Options"
                                            ? "Settings"
                                            : rolePermissionList[selectedRowIndex].SystemCategoryPageDescription
                                    )}
                                </h3>

                                <div
                                    className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={closeModal}
                                >
                                    <KTSVG
                                        path="/media/icons/duotune/arrows/arr061.svg"
                                        className="svg-icon svg-icon-1x"
                                    />
                                </div>
                            </div>
                            <div className="modal-body text-align-center d-flex justify-content-center flex-column"  >
                                <table className="table table-row-bordered table-row-gray-300 align-middle gs-0 gy-4" >
                                    <thead>
                                        <tr className="fw-bold text-muted thHeading" style={{ fontSize: '10px', fontWeight: '500' }}>
                                            <th className='min-w-100% '>
                                                {/* {t('Active Permissions')} */}
                                                {getValueFromResource('Active Permissions', dispatch, t)}
                                            </th>
                                            {isShowDataOptions ? (
                                                <>
                                                    <th className='min-w-100% text-center'>
                                                        {/* {t('All')} */}
                                                        {getValueFromResource('All', dispatch, t)}
                                                    </th>
                                                   {/* {schedulePageId !== 509 &&  */}
                                                   <th className='min-w-100% text-center'>
                                                        {/* {t('My')} */}
                                                        {getValueFromResource('My', dispatch, t)}
                                                    </th>
                                                    {/* } */}
                                                    {schedulePageId !== 80 && (
                                                    <th className='min-w-100% text-center'>
                                                        {/* {t('My Projects')} */}
                                                        {getValueFromResource('My Projects', dispatch, t)}
                                                    </th>
                                                    )}
                                                   {schedulePageId !== 509 && schedulePageId !== 80 &&  <th className='min-w-100% text-center'>
                                                        {/* {t('My Teams')} */}
                                                        {getValueFromResource('My Teams', dispatch, t)}
                                                    </th>}
                                                   {schedulePageId !== 509 && <th className='min-w-100% text-center'>
                                                        {/* {t('My Sub-Ordinate')} */}
                                                        {getValueFromResource('My Sub-Ordinate', dispatch, t)}
                                                    </th>}
                                                </>
                                            ) : null
                                            }

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {rolePermissionList.length > 0 && rolePermissionList
                                            .filter((item: any) => item.SystemSecurityCategoryPageId === systemSecurityCategoryPageId)
                                            .map((Detail: any, i: any) => {
                                                const founditem: any = rolePermissionReadOnlyList.find((item: any) => item.SystemSecurityCategoryPageId === systemSecurityCategoryPageId)
                                                return (

                                                    <React.Fragment key={`detail-${i}`}>
                                                        {permissionList.map((permission: any, index: any) => (
                                                            founditem[permission.name] === true && (
                                                                <tr key={`permission-${index}`}>
                                                                    {/* <td className="text-center">
                                                                        <div className={`border d-flex justify-content-center align-items-center p-2 ${isShowDataOptions ? 'custom-width' : ''} `}>
                                                                            <div className="flex-grow-1 d-flex align-items-center">
                                                                                <i className={`fa fa-${permission.icon} custom-padding-right`} style={{ color: `${permission.iconColor}` }}></i>
                                                                                <span>{permission.displayname}</span>
                                                                            </div>
                                                                            <div className="form-check form-switch">
                                                                                <input
                                                                                    type="checkbox"
                                                                                    className="form-check-input custom-padding-right h-20px"
                                                                                    id={`${permission.name}`}
                                                                                    checked={applyPermissionInModal(Detail, permission, wholeAccountPermissionsArray)}
                                                                                    onChange={(e) => { handlePermissionInModalChange(e, Detail, permission, wholeAccountPermissionsArray) }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </td> */}

                                                                    {(() => {

                                                                        if (
                                                                            Detail.SystemSecurityCategoryPageId === 507 &&
                                                                            (permission.displayname === "List \ View" || permission.displayname === "Edit")
                                                                        ) {
                                                                            return null;
                                                                        }
                                                                         if (
                                                                            Detail.SystemSecurityCategoryPageId === 506 &&
                                                                            (permission.displayname === "Delete")
                                                                        ) {
                                                                            return null;
                                                                        }
                                                                        return (
                                                                            <td className="text-center">
                                                                                <div
                                                                                    className={`border d-flex justify-content-center align-items-center p-2 ${isShowDataOptions ? "custom-width" : ""
                                                                                        }`}
                                                                                >
                                                                                    <div className="flex-grow-1 d-flex align-items-center">
                                                                                        <i
                                                                                            className={`fa fa-${permission.icon} custom-padding-right`}
                                                                                            style={{ color: `${permission.iconColor}` }}
                                                                                        ></i>
                                                                                        <span>{getValueFromResource(`${permission.displayname}`, dispatch, t)}</span>
                                                                                    </div>
                                                                                    <div className="form-check form-switch">
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            className="form-check-input custom-padding-right h-20px"
                                                                                            id={`${permission.name}`}
                                                                                            checked={applyPermissionInModal(
                                                                                                Detail,
                                                                                                permission,
                                                                                                wholeAccountPermissionsArray
                                                                                            )}
                                                                                            onChange={(e) =>
                                                                                                handlePermissionInModalChange(
                                                                                                    e,
                                                                                                    Detail,
                                                                                                    permission,
                                                                                                    wholeAccountPermissionsArray
                                                                                                )
                                                                                            }
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                        );
                                                                    })()}                          

                                                                    {wholeAccountPermissionsArray
                                                                        .filter((item: any) => item.SystemSecurityCategoryPageId === Detail.SystemSecurityCategoryPageId && item.SystemPermissionId === permission.id)
                                                                        .map((wholeAccountPermissionsRow: any, i: any) => {
                                                                            if (
                                                                                wholeAccountPermissionsRow.AccountId === sessionAccountId &&
                                                                                wholeAccountPermissionsRow.AccountRoleId === selectedAccountRole?.value &&
                                                                                Detail.SystemSecurityCategoryPageId === wholeAccountPermissionsRow.SystemSecurityCategoryPageId
                                                                            ) {
                                                                                switch (wholeAccountPermissionsRow.SystemPermissionId) {
                                                                                    case 1:                                                                                       
                                                                                        return (
                                                                                            <React.Fragment>
                                                                                                {Detail.IsAllowList && Detail.IsShowDataOptions && (
                                                                                                    <>
                                                                                                        <td className="text-center">
                                                                                                            <input
                                                                                                                type="checkbox"
                                                                                                                className="form-check-input  custom-padding-right small-checkbox"
                                                                                                                id="ShowAllData"
                                                                                                                checked={wholeAccountPermissionsRow.ShowAllData}
                                                                                                                onChange={(e) => { handleCheckboxChange(e, wholeAccountPermissionsRow) }} />

                                                                                                        </td>
                                                                                                        {/* {schedulePageId !== 509 &&  */}
                                                                                                        <td className="text-center">
                                                                                                            <input
                                                                                                                type="checkbox"
                                                                                                                className="form-check-input custom-padding-right small-checkbox"
                                                                                                                id="ShowMyData"
                                                                                                                checked={wholeAccountPermissionsRow.ShowMyData}
                                                                                                                onChange={(e) => { handleCheckboxChange(e, wholeAccountPermissionsRow) }}
                                                                                                            />
                                                                                                        </td>
                                                                                                        {/* } */}
                                                                                                        {(Detail.SystemSecurityCategoryPageId == 124 || Detail.SystemSecurityCategoryPageId == 27) &&
                                                                                                            Detail.IsShowDataOptions &&
                                                                                                            Detail.IsAllowList && (
                                                                                                                setListViewDataOptionsByPageId(Detail, wholeAccountPermissionsRow)
                                                                                                            )}
                                                                                                        {Detail.SystemSecurityCategoryPageId !== 124 && Detail.SystemSecurityCategoryPageId !== 27 && (
                                                                                                            setListViewDataOptionsByPageId(Detail, wholeAccountPermissionsRow)
                                                                                                        )}
                                                                                                    </>
                                                                                                )}
                                                                                            </React.Fragment>
                                                                                        );
                                                                                    case 2:
                                                                                        return (
                                                                                            <React.Fragment>
                                                                                                {(Detail.IsAllowAdd && Detail.IsShowDataOptions) && (
                                                                                                    <>
                                                                                                        {(Detail.SystemSecurityCategoryPageId == 124 || Detail.SystemSecurityCategoryPageId == 27 || Detail.SystemSecurityCategoryPageId == 18 || Detail.SystemSecurityCategoryPageId == 135) &&
                                                                                                            Detail.IsShowDataOptions &&
                                                                                                            Detail.IsAllowAdd && (
                                                                                                                setAddDataOptionsByPageId(Detail, wholeAccountPermissionsRow)
                                                                                                            )}
                                                                                                        {Detail.SystemSecurityCategoryPageId !== 124 && Detail.SystemSecurityCategoryPageId !== 27 && Detail.SystemSecurityCategoryPageId !== 18 && Detail.SystemSecurityCategoryPageId !== 135 && (
                                                                                                            setAddDataOptionsByPageId(Detail, wholeAccountPermissionsRow)
                                                                                                        )}
                                                                                                    </>
                                                                                                )}
                                                                                            </React.Fragment>
                                                                                        );
                                                                                    case 3:
                                                                                        return (
                                                                                            <React.Fragment>
                                                                                                {(Detail.IsAllowEdit && Detail.IsShowDataOptions) && (
                                                                                                    <>
                                                                                                        {(Detail.SystemSecurityCategoryPageId == 124 || Detail.SystemSecurityCategoryPageId == 18 || Detail.SystemSecurityCategoryPageId == 135) &&
                                                                                                            Detail.IsShowDataOptions &&
                                                                                                            Detail.IsAllowEdit && (
                                                                                                                setEditDataOptionsByPageId(Detail, wholeAccountPermissionsRow)
                                                                                                            )}
                                                                                                        {Detail.SystemSecurityCategoryPageId !== 124 && Detail.SystemSecurityCategoryPageId !== 18 && Detail.SystemSecurityCategoryPageId !== 135 && (
                                                                                                            setEditDataOptionsByPageId(Detail, wholeAccountPermissionsRow)
                                                                                                        )}
                                                                                                    </>
                                                                                                )}
                                                                                            </React.Fragment>
                                                                                        );
                                                                                    case 4:
                                                                                        return (
                                                                                            <React.Fragment>
                                                                                                {(Detail.IsAllowDelete && Detail.IsShowDataOptions) && (
                                                                                                    <>
                                                                                                        {(Detail.SystemSecurityCategoryPageId == 124 || Detail.SystemSecurityCategoryPageId == 135) &&
                                                                                                            Detail.IsShowDataOptions &&
                                                                                                            Detail.IsAllowDelete && (
                                                                                                                setDeleteDataOptionsByPageId(Detail, wholeAccountPermissionsRow)
                                                                                                            )}
                                                                                                        {Detail.SystemSecurityCategoryPageId !== 124 && Detail.SystemSecurityCategoryPageId !== 18 && Detail.SystemSecurityCategoryPageId !== 135 && (
                                                                                                            setDeleteDataOptionsByPageId(Detail, wholeAccountPermissionsRow)
                                                                                                        )}
                                                                                                    </>
                                                                                                )}
                                                                                            </React.Fragment>
                                                                                        );
                                                                                    default:
                                                                                        return null;
                                                                                }
                                                                            } else {
                                                                                return null;
                                                                            }
                                                                        })}
                                                                </tr>
                                                            )
                                                        ))}
                                                    </React.Fragment>
                                                )
                                            })}
                                    </tbody>
                                </table>


                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                    data-bs-dismiss="modal"
                                    onClick={closeModal}
                                >
                                    {/* {t('Cancel')} */}
                                    {getValueFromResource('Cancel', dispatch, t)}
                                </button>
                                {IsEdit &&
                                    <button
                                        type="button"
                                        id="btnCheckIn"
                                        className="btn  btn-primary btn-bs-btn-font-weight btn-sm"
                                        onClick={() => updatepermissions()}
                                    >
                                        {/* {t('Update')} */}
                                        {getValueFromResource('Update', dispatch, t)}
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            }
            <ReactTooltip
                id="tooltip-role-permission"
                style={TOOLTIP_STYLE}
                place="top"
                delayShow={100}
                delayHide={100}
                clickable
                render={({ content }) => {
                    const isLongContent = content && content?.length > 90;
                    return (
                        <div style={{ maxWidth: isLongContent ? '380px' : '220px' }}>
                            {content}
                        </div>
                    );
                }}
            />

        </>
    )
}

const dropDownSelectionStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '210px', minHeight: '41px', height: '41px' }),
}
// const colourStyles: StylesConfig = {
//     control: (styles) => ({ ...styles, backgroundColor: 'white', width: 200, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px' })
// }


